import { AnyAction } from "redux"

import { Page } from "../../containers/content-factory/types"
import { Tab } from "../../containers/content-factory/utils"
import {
  SET_CF_LAST_ENQUEUED_MESSAGE,
  SET_CF_PAGE,
  SET_CF_TAB,
  OPEN_CF_PROFILE_READY_DIALOG,
  DISMISS_CF_PROFILE_READY_DIALOG,
  UpdateMessage,
} from "../actions/ContentFactoryActions"

export type ContentFactoryState = {
  latestMessageByPostBatchId: Record<string, UpdateMessage | undefined>
  currentPage: Page | null
  currentPostBatchId: string
  currentTab: Tab | null
  profileReadyDialogBatchIds: string[]
}

const initialState: ContentFactoryState = {
  latestMessageByPostBatchId: {},
  currentPage: null,
  currentPostBatchId: "",
  currentTab: null,
  profileReadyDialogBatchIds: [],
}

const contentFactoryReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_CF_LAST_ENQUEUED_MESSAGE: {
      const { postBatchId, message } = action.payload
      return {
        ...state,
        latestMessageByPostBatchId: {
          ...state.latestMessageByPostBatchId,
          [postBatchId]: message,
        },
      }
    }

    case SET_CF_PAGE: {
      const { page, postBatchId } = action.payload
      return {
        ...state,
        currentPage: page,
        currentPostBatchId: postBatchId,
      }
    }

    case SET_CF_TAB: {
      return {
        ...state,
        currentTab: action.payload.tab,
      }
    }

    case OPEN_CF_PROFILE_READY_DIALOG: {
      const { batchId } = action.payload
      if (state.profileReadyDialogBatchIds.includes(batchId)) return state
      return {
        ...state,
        profileReadyDialogBatchIds: [...state.profileReadyDialogBatchIds, batchId],
      }
    }

    case DISMISS_CF_PROFILE_READY_DIALOG: {
      const { batchId } = action.payload
      return {
        ...state,
        profileReadyDialogBatchIds: state.profileReadyDialogBatchIds.filter(id => id !== batchId),
      }
    }

    default:
      return state
  }
}

export default contentFactoryReducer
